const GENERIC_ERROR = '¡Ocurrió un error inesperado!. Por favor inténtelo nuevamente.';

export const getErrorMessage = (error) => {
  if (error) {
    if (typeof error === 'string') return error;
    else if (error.name !== 'Error') return error.message;
    else return GENERIC_ERROR;
  } else return GENERIC_ERROR;
};
